import { all } from 'redux-saga/effects';
import { policySagas } from './policy';
import { paymentSagas } from './payment';

export const rootSaga = function* root() {
  yield all([policySagas(), paymentSagas()]);
};
